import React from "react";
import { type FreefieldInputProps } from "../models";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

const FreefieldBoolean = (props: FreefieldInputProps) => {
  const [checked, setChecked] = React.useState<boolean | undefined>(props.initialValue === "true");

  const onChange = (value: boolean) => {
    setChecked(value);

    if (value) props.onChange("true");
    else if (!value) props.onChange("false");
  };

  return <Checkbox
    checked={checked}
    onChange={() => { onChange(!checked); }}
  />;
};

export default FreefieldBoolean;